import { render } from "./ChatNew.vue?vue&type=template&id=7c515806&scoped=true"
import script from "./ChatNew.vue?vue&type=script&lang=js"
export * from "./ChatNew.vue?vue&type=script&lang=js"

import "./ChatNew.vue?vue&type=style&index=0&id=7c515806&lang=css"
import "./ChatNew.vue?vue&type=style&index=1&id=7c515806&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c515806"]])

export default __exports__